type CartUserError = {
   field?: string[] | null;
   message?: string | null;
};

type CartMutationResult = {
   cart?: { buyerIdentity: { customer?: { id: string } | null } } | null;
   userErrors?: CartUserError[] | null;
};

/**
 * `field` points at the token on both mutations that carry one, in any language:
 *
 *   cartCreate               ["input", "buyerIdentity", "customerAccessToken"]
 *   cartBuyerIdentityUpdate  ["buyerIdentity", "customerAccessToken"]
 */
export function wasCustomerTokenRejected(
   result: CartMutationResult | null | undefined,
   sentToken: string | undefined
): boolean {
   if (!sentToken) {
      return false;
   }
   const errors = result?.userErrors ?? [];
   return (
      errors.some(error => error.field?.includes('customerAccessToken')) ||
      (result?.cart != null && result.cart.buyerIdentity.customer == null)
   );
}
